import type { ReactNode } from 'react';
import { card } from '../../../styled-system/recipes';
import { cx } from '../../../styled-system/css';

export type CardProps = { children: ReactNode; className?: string };

export function Card({ children, className }: CardProps) {
  return <div className={cx(card(), className)}>{children}</div>;
}
